import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuDataCollectionView } from "src/tenantCustomizations/tenants/mellano/views/luukku/slotting/MellanoLuukkuDataCollectionView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/dataCollection")({
	staticData: { title: "Tiedonkeruu", legacyViewKey: "mellanoLuukkuDataCollectionView" },
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<MellanoLuukkuDataCollectionView modes={["WORK_ORDER_SLOT", "DELIVERY_BATCH_SLOTS", "PURCHASE_SUGGESTION"]} />
	);
}
